import { Button } from "@components/button/button-untitledui";
import { ArrowRight } from "@untitledui/icons";
import dayjs from "dayjs";
import type { VehicleOdometerDetailResponse } from "@/features/vehicle/types/odometer-ui.types";
import { VEHICLE_ODOMETER_SOURCE } from "@/features/vehicle/types/odometer-ui.types";

function formatDetailSourceLabel(source?: number): string {
	if (source === VEHICLE_ODOMETER_SOURCE.TELEMETRY) {
		return "Telemetria";
	}
	if (source === VEHICLE_ODOMETER_SOURCE.CHECKLIST) {
		return "Checklist";
	}
	return "Manual";
}

type OdometerAttachmentPreviewModalProps = {
	detail: VehicleOdometerDetailResponse | undefined;
	onClose: () => void;
};

export function OdometerAttachmentPreviewModal({
	detail,
	onClose,
}: OdometerAttachmentPreviewModalProps) {
	return (
		<div className="fixed inset-0 z-40 flex items-center justify-center bg-overlay/70 p-4">
			<div className="w-full max-w-[400px] overflow-hidden rounded-2xl bg-white shadow-xl">
				<div className="p-6">
					<div className="aspect-352/264 w-full overflow-hidden rounded-lg bg-black">
						{detail?.attachmentUrl ? (
							/* biome-ignore lint/performance/noImgElement: URL served by backend for evidence preview */
							<img
								alt="Painel do hodômetro"
								className="size-full object-cover"
								height={264}
								src={detail.attachmentUrl}
								width={352}
							/>
						) : (
							<div className="flex size-full items-center justify-center text-fg-secondary text-sm">
								Sem visualização de anexo
							</div>
						)}
					</div>
				</div>
				<div className="px-6 pb-8">
					<div className="mb-4 flex items-center justify-between gap-2">
						<p className="flex-1 font-bold text-fg-primary text-lg">
							{detail?.brand ?? "-"} - {detail?.model ?? "-"}
						</p>
						<span className="flex-1 font-bold text-primary text-xs">
							{detail?.plate ?? "-"}
						</span>
					</div>
					<div className="grid grid-cols-[98px_1fr] gap-y-1 text-sm">
						<span className="font-bold text-fg-tertiary">Responsável:</span>
						<span className="text-fg-tertiary">
							{detail?.updatedBy ?? "Sistema"}
						</span>
						<span className="font-bold text-fg-tertiary">Data e Hora:</span>
						<span className="text-fg-tertiary">
							{detail?.readingDateTime
								? dayjs(detail.readingDateTime).format("DD/MM/YYYY - HH:mm")
								: "-"}
						</span>
						<span className="font-bold text-fg-tertiary">De - Para:</span>
						<div className="flex items-center gap-2">
							<span className="text-fg-tertiary line-through">
								{detail?.previousOdometer !== null &&
								detail?.previousOdometer !== undefined
									? `${detail.previousOdometer.toLocaleString("pt-BR")}km`
									: "-"}
							</span>
							<ArrowRight className="size-3.5" />
							<span className="font-bold text-fg-primary">
								{detail?.newOdometer !== undefined
									? `${detail.newOdometer.toLocaleString("pt-BR")}km`
									: "-"}
							</span>
						</div>
						<span className="font-bold text-fg-secondary">Origem:</span>
						<span className="text-fg-secondary">
							{formatDetailSourceLabel(detail?.source)}
						</span>
					</div>
				</div>
				<div className="p-6 pt-0">
					<Button
						aria-label="Fechar modal de anexo"
						className="w-full"
						color="secondary"
						onClick={onClose}
						size="lg"
					>
						Fechar
					</Button>
				</div>
			</div>
		</div>
	);
}
